export const ADD_SUCCESS_MESSAGE = 'ADD_SUCCESS_MESSAGE';
export const REMOVE_SUCCESS_MESSAGE = 'REMOVE_SUCCESS_MESSAGE';
export const ADD_ERROR_MESSAGE = 'ADD_ERROR_MESSAGE';
export const REMOVE_ERROR_MESSAGE = 'REMOVE_ERROR_MESSAGE';
export const REMOVE_ALL_MESSAGES = 'REMOVE_ALL_MESSAGES';


export function addSuccessMessage(heading, content) {
    return {
        type: ADD_SUCCESS_MESSAGE,
        heading,
        content,
    }
}

export function removeSuccessMessage(heading) {
    return {
        type: REMOVE_SUCCESS_MESSAGE,
        heading,
    }
}

export function addErrorMessage(heading, content) {
    return {
        type: ADD_ERROR_MESSAGE,
        heading,
        content,
    }
}

export function removeErrorMessage(heading) {
    return {
        type: REMOVE_ERROR_MESSAGE,
        heading,
    }
}

export function removeAllMessages() {
    return {
        type: REMOVE_ALL_MESSAGES,
    }
}